import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as ExperiencesActions from "../../actions/experiencesActions";
import * as constants from "../../constants";

const deleteExperienceLogic = createLogic({
	type: ActionTypes.DELETE_EXPERIENCE,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					headers: { Authorization: "Bearer " + token },
				});
				api.delete(`/experiences/${action.experienceId}`)
					.then(() => {
						dispatch(ExperiencesActions.deleteExperienceSuccess());
						done();
					})
					.catch(error => {
						dispatch(ExperiencesActions.deleteExperienceFail(error));
						done();
					});
			});
	},
});

export default [deleteExperienceLogic];
